import React, { useEffect } from 'react';
import './../../styles/cliente/home.css';
import { useNavigate } from 'react-router-dom';

const Cliente_home = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/cliente/menu');
    }, []);

    return (
        <div>
            Cargando...
        </div>
    );
};

export default Cliente_home;